type PriceTagProps = {
  amount: string;
  originalAmount?: string;
  period?: string;
  periodAsSibling?: boolean;
  amountClassName?: string;
  originalAmountClassName?: string;
  periodClassName?: string;
};

export const PriceTag = ({
  amount,
  originalAmount,
  period,
  periodAsSibling,
  amountClassName,
  originalAmountClassName,
  periodClassName,
}: PriceTagProps) => {
  const periodNode = period ? (
    <span className={periodClassName}>{period}</span>
  ) : null;

  return (
    <>
      {originalAmount ? (
        <s className={originalAmountClassName}>{originalAmount}</s>
      ) : null}
      <span className={amountClassName}>
        {amount}
        {periodAsSibling ? null : periodNode}
      </span>
      {periodAsSibling ? periodNode : null}
    </>
  );
};
